<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div class="file-upload" @click="openFileDialog" @dragover.prevent @drop="handleFileDrop" @keyup="openFileDialog">
    <div v-if="!props.modelValue" class="file-upload__content">
      <div class="file-upload__content__top">
        <slot name="top" />
      </div>
      <div v-if="props.title" class="file-upload__title">{{ props.title }}</div>
      <div v-if="props.description" class="file-upload__description">{{ props.description }}</div>
      <slot />
    </div>
    <div v-else class="file-upload__file">
      <img v-if="previewUrl" :src="previewUrl" alt="" />
    </div>
    <input ref="fileInput" type="file" style="display: none" @change="handleFileSelect" />
  </div>
</template>

<script setup lang="ts">
import { PropType, ref, watch } from 'vue';

const props = defineProps({
  title: {
    type: String as PropType<string>,
    required: false,
  },
  description: {
    type: String as PropType<string>,
    required: false,
  },
  modelValue: {
    type: File as PropType<File>,
    required: false,
  },
});

const emits = defineEmits(['update:modelValue']);

const fileInput = ref<HTMLInputElement | null>(null);
const previewUrl = ref<string>('');

const openFileDialog = (): void => {
  fileInput.value?.click();
};

const handleFileSelect = (event: Event): void => {
  const { files } = event.target as HTMLInputElement;
  if (files && files.length > 0) {
    emits('update:modelValue', files[0]);
  }
};

const handleFileDrop = (event: DragEvent): void => {
  event.preventDefault();
  const files = event.dataTransfer?.files;
  if (files && files.length > 0) {
    emits('update:modelValue', files[0]);
  }
};

const previewImage = (file: File): void => {
  if (file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.onload = () => {
      previewUrl.value = reader.result as string;
    };
    reader.readAsDataURL(file);
  }
};

defineExpose({
  openFileDialog,
});

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal) {
      previewImage(newVal);
    }
  },
);
</script>

<style scoped lang="scss" src="./AiFileUpload.scss" />
